import { apiClient } from "./apiClient";
import type {
  ImportApplyResult,
  ImportPreviewResponse,
  ImportRow,
} from "../../types/contact-import";

export const contactImportService = {
  async preview(file: File): Promise<ImportPreviewResponse> {
    const fd = new FormData();
    fd.append("file", file, file.name);
    const r = await apiClient.post<ImportPreviewResponse>(
      "/admin/contacts/import/preview/",
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return r.data;
  },

  async apply(rows: ImportRow[]): Promise<ImportApplyResult> {
    const r = await apiClient.post<ImportApplyResult>(
      "/admin/contacts/import/apply/",
      { rows },
    );
    return r.data;
  },
};

export default contactImportService;
